<template>
  <section class="data-section" style="z-index: 5">
    <div
      class="data-piece"
      v-for="(item, index) in datas"
      :key="index"
      :id="index == 1 ? 'centermargin' : ''"
    >
      <!-- <i :class="item.icon"></i> -->
      <div class="num">{{ item.num }}</div>
      <div class="data-desc">{{ item.desc }}</div>
    </div>
  </section>
</template>

<script>
export default {
  name: "InfoCount",
  data() {
    return {
      datas: [
        {
          icon: "fa fa-code",
          num: '',
          desc: "Countries",
        },
        {
          icon: "fa fa-money",
          num: '',
          desc: "Universities/Institutions",
        },
        {
          icon: "fa fa-eye",
          num: "",
          desc: "Members",
        },
      ],
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      let ucode = "0869f7371a1d4e8bb30d9509a4b8411d";
      let url = `${window._CONFIG["domianURL"]}xmu/index/getData/${ucode}?`;
      let params = {
        pageNo:1,
        pageSize:999,
        is_publish: 1,
        column: "id",
        order: "desc",
        superQueryMatchType: "and",
      };
      this.$axios({
        method: "get",
        url: url,
        params: params,
      }).then((res) => {
        let data = res.data.result.records[0];
        this.datas[0].num=data.country
        this.datas[1].num=data.org
        this.datas[2].num=data.partner
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#centermargin {
  margin: 0 40px;
}
.num {
  font-size: 90px;
  font-family: Agency FB;
  font-weight: bold;
  color: #ffffff;
  line-height: 20px;
  text-shadow: 0px 7px 4px rgba(0, 0, 0, 0.45);
}

.data-desc {
  font-family: "Oswald-Light";
  font-weight: 300;
  color: #ffffff;
  line-height: 36px;
}
</style>
